// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as V3CustomTableContext$LiteracyplanetTupperware from "./V3CustomTableContext.res.mjs";

function V3CustomTableCell(props) {
  var children = props.children;
  var colIndex = props.colIndex;
  var rowIndex = props.rowIndex;
  var match = Curry._1(V3CustomTableContext$LiteracyplanetTupperware.use, undefined);
  var kind = match.kind;
  if (typeof kind !== "object") {
    switch (kind) {
      case "GridMatchLeftToRight" :
          if (colIndex === 0) {
            return React.createElement("td", {
                        className: "gridMatchLeftToRightCellFirst"
                      }, children);
          }
          if (colIndex === 1) {
            return React.createElement(React.Fragment, {
                        children: Caml_option.some(React.createElement("td", {
                                  className: "gridMatchLeftToRightCellSecond"
                                }, children))
                      });
          }
          break;
      case "GridMatchRightToLeft" :
          if (colIndex === 0) {
            return React.createElement(React.Fragment, {
                        children: Caml_option.some(React.createElement("div", {
                                  className: "gridMatchRightToLeftCellFirst"
                                }, children))
                      });
          }
          if (colIndex === 1) {
            return React.createElement("div", {
                        className: "gridMatchRightToLeftCellSecond"
                      }, children);
          }
          break;
      case "InstructionAndHint" :
          if (colIndex === 0) {
            if (rowIndex === 0) {
              return React.createElement("div", {
                          className: ""
                        }, children);
            }
            if (rowIndex === 1) {
              return React.createElement("div", {
                          className: "text-sm font-thin"
                        }, children);
            }
            
          }
          break;
      
    }
  } else {
    if (kind.TAG === "HighlightResponseSets") {
      return children;
    }
    if (!kind.hasStem) {
      return React.createElement("div", {
                  className: "pilot-multi-response-sets-cell-no-stem"
                }, children);
    }
    if (colIndex === 0) {
      return React.createElement("div", {
                  className: "pilot-multi-response-sets-cell-left"
                }, children);
    }
    if (colIndex === 1) {
      return React.createElement("div", {
                  className: "pilot-multi-response-sets-cell-right"
                }, children);
    }
    
  }
  throw {
        RE_EXN_ID: "Match_failure",
        _1: [
          "V3CustomTableCell.res",
          4,
          2
        ],
        Error: new Error()
      };
}

var make = V3CustomTableCell;

var $$default = V3CustomTableCell;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
